import React, { useState, useEffect, useRef } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { useInView } from 'react-intersection-observer';
import activedBlack from './../../assets/images/actived-black.png'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux';
import EmpowerActions from 'stores/leadbest-official-website/empower/actions'
import Pagination from '@material-ui/lab/Pagination';
import { Link } from "react-router-dom";
import Skeleton from '@material-ui/lab/Skeleton';
import loadingPicture from './../../assets/images/loading-picture.png'
import languages from 'locales';
import { injectIntl } from 'react-intl';
import PaginationItem from '@material-ui/lab/PaginationItem';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#001229",
        color: "#fff",
        "& .title-block": {
            marginTop: "-280px",
            padding: "140px 0px 70px 0px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            [theme.breakpoints.down('sm')]: {
                padding: "100px 0px 50px 0px",
            },
            [theme.breakpoints.down('sm')]: {
                padding: "60px 0px 40px 0px",
            },
        },
        "& .title": {
            textAlign: "center",
            transform: "translateY(50px)",
            opacity: "0",
            transition: "0.6s",
            "&.inView": {
                transform: "translateY(0px)",
                opacity: "1",
            }
        },
        "& .subtitle": {
            marginTop: "12px",
            color: "rgba(255,255,255,0.2)",
            textAlign: "center",
            transform: "translateY(50px)",
            opacity: "0",
            transition: "0.6s",
            "&.inView": {
                transform: "translateY(0px)",
                opacity: "1",
            }
        },
        "& .content-block": {
            position: "relative",
            background: "#f5f5f5",
            transition: "0.6s",
            paddingBottom: "60px",
            "&:before": {
                transition: "0.6s",
                position: "absolute",
                top: "-120px",
                left: "0px",
                content: "''",
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "120px 0 0 50vw",
                borderColor: "transparent transparent transparent #f5f5f5",
                [theme.breakpoints.down('sm')]: {
                    top: "-60px",
                    borderWidth: "60px 0 0 50vw",
                },
                [theme.breakpoints.down('xs')]: {
                    top: "-39px",
                    borderWidth: "40px 0 0 50vw",
                },
            },
            "&:after": {
                transition: "0.6s",
                position: "absolute",
                top: "-120px",
                right: "0px",
                content: "''",
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 0 120px 50vw",
                borderColor: "transparent transparent #f5f5f5 transparent",
                [theme.breakpoints.down('sm')]: {
                    top: "-60px",
                    borderWidth: "0 0 60px 50vw",
                },
                [theme.breakpoints.down('xs')]: {
                    top: "-39px",
                    borderWidth: "0 0 40px 50vw",
                },

            },
            [theme.breakpoints.down('sm')]: {
                paddingBottom: "25px",
            }
        },
        "& .category-block": {
            display: "flex",
            justifyContent: "space-between",
            maxWidth: "500px",
            margin: "0px auto",
            padding: "60px 24px 24px 24px ",
            [theme.breakpoints.down('sm')]: {
                maxWidth: "600px",
                padding: "40px 24px 24px 24px",
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: "400px",
                padding: "30px 24px 24px 24px",
            },
        },
        "& .category": {
            cursor: "pointer",
            transiton: "0.3s",
            color: "#001229",
            opacity: "0.5",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
            whiteSpace: "nowrap",
            [theme.breakpoints.down('xs')]: {
                fontSize: "14px",
            },
            "&:hover": {
                opacity: "0.7"
            },
            "&.actived": {
                opacity: "1",
                outline: "none",
            }
        },
        "& .actived-icon": {
            display: "inline-block",
            width: "12px",
            height: "12px",
            marginRight: "12px"
        },
        "& .card-block": {
            width: "100%",
            maxWidth: "1300px",
            margin: "0px auto",
            padding: "0px 24px"
        },
        "& .card": {
            cursor: "pointer",
            "&:hover": {
                "& .card-picture": {
                    transform: "scale(1.1)",
                }
            }
        },
        "& .card-picture-block": {
            overflow: "hidden",
            width: "100%",
            height: "230px",
            [theme.breakpoints.down('xs')]: {
                height: "182px",
            }
        },
        "& .card-picture": {
            transition: "0.3s",
            transform: "scale(1)",
            width: "100%",
            height: "100%",
            objectFit: "cover"
        },
        "& .card-info": {
            padding: "28px 23px",
            background: "#fff",
            minHeight: "190px",
            [theme.breakpoints.down('xs')]: {
                padding: "21px 19px",
                minHeight: "170px",
            }
        },
        "& .card-title": {
            color: "rgba(0,18,41,0.5)",
            fontSize: "20px",
            lineHeight: "27px",
            fontWeight: "bold",
            marginBottom: "12px",
            "&.en": {
                fontSize: "16px",
            }
        },
        "& .card-description": {
            fontSize: "20px",
            lineHeight: "27px",
            fontWeight: "bold",
            color: "#001229",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            "&.en": {
                fontSize: "16px",
            }
        }
    }
}))

const PaginationCustom = withStyles({
    root: {
        '& .MuiPaginationItem-outlined': {
            color: "#001229",
            borderRadius: "4px",
            border: 'unset',
            fontWeight: "normal",
        },
        '& .Mui-selected, & .MuiPaginationItem-page:hover': {
            backgroundColor: '#001229',
            color: '#fff'
        }
    },
    ul: {
        justifyContent: 'center'
    }
})(Pagination);

const List = (props: any) => {
    const classes = useStyles()
    const dispatch = useDispatch();
    const empowerSelector = useSelector((state: any) => state.leadbest.empower);
    const global = useSelector((state: any) => state.global);
    const isEnglish = global.locale == 'en_us'
    const languagesIndex = languages[global.locale].id;

    const empower = empowerSelector.empower
    const { isMobileScreen, category, page, intl, anchor } = props

    // const categoryArray = [{ name: "全部", value: "ALL" }, { name: "數位賦能案", value: "DIGITAL_EMPOWERMENT" }, { name: "賦能型風險投資案", value: "VENTURE_CAPITAL" }]
    const categoryArray = ["ALL", "DIGITAL_EMPOWERMENT", "VENTURE_CAPITAL"]

    const [titleRef, titleInView, titleEntry] = useInView(
        {
            threshold: 0,
        });


    const params: any = {
        category: category || "ALL",
        page: page
    }

    useEffect(() => {
        if (empower.loading) return;
        dispatch(EmpowerActions.getEmpowerRequest({ params: params }));
    }, [category, page])

    const correspondingLanguage = (translations: any) => {
        const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
        return translations.find((item: any) => item.languages_code == language)
    }
    const anchorRef: any = useRef(null)

    useEffect(() => {
        if (!anchor) return;
        window.scrollTo({
            top: anchorRef.current.offsetTop, behavior: 'smooth'
        });
    }, [anchor, category])
    return (
        <div className={classes.root} id="list" ref={anchorRef}>
            <div className="title-block" >
                <Typography className={clsx("title", titleInView && "inView")} variant="h3">{intl.formatMessage({ id: "empowerList.list.title" })}</Typography>
                <Typography className={clsx("subtitle", titleInView && "inView")} variant="h6" ref={titleRef}>{intl.formatMessage({ id: "empowerList.list.subtitle" })}</Typography>
            </div>
            <div className="content-block">
                <div className="category-block">
                    {categoryArray.map((item: any, index: number) =>
                        <Link to={`/empower?${new URLSearchParams({ ...params, category: item, page: 1 })}`} className={clsx("category", category == item && "actived")} key={index} >
                            {category == item && <img className="actived-icon" src={activedBlack} alt="actived-icon" />}
                            {intl.formatMessage({ id: `empowerList.list.category.${item}` })}
                        </Link>
                    )}
                </div>
                <Grid container spacing={3} className="card-block">
                    {empower.loading &&
                        Array.from(new Array(9), (val, index) => {
                            return (
                                <Grid key={index} item xs={12} sm={6} md={4} >
                                    <Box>
                                        <img src={loadingPicture} alt="loading-picture" style={{ width: "100%", height: 228, marginBottom: 28, objectFit: "cover" }} />
                                        <Skeleton animation="wave" variant="rect" height={27} width="50%" style={{ marginBottom: 12 }} />
                                        <Skeleton animation="wave" variant="rect" height={20} width="100%" style={{ marginBottom: 8 }} />
                                        <Skeleton animation="wave" variant="rect" height={20} width="100%" style={{ marginBottom: 8 }} />
                                    </Box>
                                </Grid>
                            )
                        })
                    }
                    {!empower.loading && empower.loaded &&
                        empower.data.map(((item: any, index: number) =>
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Link to={`/empower/${item.id}`} className="card" >
                                    <div className="card-picture-block" >
                                        <img className="card-picture" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.cover?.id}?fit=cover&width=400&height=230`} alt="card-picture" />
                                    </div>
                                    <div className="card-info">
                                        <div className={clsx("card-title", isEnglish && "en")}>{correspondingLanguage(item.translations)?.customer}</div>
                                        <div className={clsx("card-description", isEnglish && "en")}>{correspondingLanguage(item.translations)?.description}</div>
                                    </div>
                                </Link>
                            </Grid>
                        ))
                    }
                </Grid>
                <Box mt={isMobileScreen && 7 || 10} mb={isMobileScreen && 7 || 0} textAlign="center">
                    <PaginationCustom
                        page={page}
                        count={Math.ceil(empower?.filter_count / 9)}
                        siblingCount={0} boundaryCount={2} variant="outlined" shape="rounded"
                        renderItem={(item: any) => (
                            <PaginationItem
                                component={Link}
                                to={`/empower?${new URLSearchParams({ ...params, page: item.page })}`}
                                {...item}
                            />
                        )}
                    />
                </Box>
            </div>
        </div>
    )
}
export default injectIntl(List)